import React, { useRef, useState, MouseEvent, TouchEvent } from 'react';
import style from './keybenefis.module.sass';
import KeyBenefis__icon from '../../../assets/images/KeyBenefis__icon_1440.png';
import KeyBenefis__icon_en from '../../../assets/images/KeyBenefis__icon_1440_en.png';
import KeyBenefis__icon_1920 from '../../../assets/images/KeyBenefis__icon_1920.png';
import KeyBenefis__icon_1920_en from '../../../assets/images/KeyBenefis__icon_1920_en.png';
import KeyBenefis__icon_500 from '../../../assets/images/KeyBenefis__icon_500.png';
import KeyBenefis__icon_900 from '../../../assets/images/KeyBenefis__icon_900.png';
import KeyBenefis__icon_500_en from '../../../assets/images/KeyBenefis__icon_500_en.png';
import KeyBenefis__icon_900_en from '../../../assets/images/KeyBenefis__icon_900_en.png';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

export default function KeyBenefis() {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(0);
  const [offsetX, setOffsetX] = useState(0);
  const wrapperRef = useRef(null);

  const handleMouseDown = (e: MouseEvent) => {
    setIsDragging(true);
    setDragStartX(e.clientX - offsetX);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (isDragging) {
      const newOffsetX = e.clientX - dragStartX;
      setOffsetX(newOffsetX);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e: TouchEvent) => {
    setIsDragging(true);
    setDragStartX(e.touches[0].clientX - offsetX);
  };

  const handleTouchMove = (e: TouchEvent) => {
    if (isDragging) {
      const newOffsetX = e.touches[0].clientX - dragStartX;
      setOffsetX(newOffsetX);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <div className={style.keyBenefis__wrapper} id="KeyBenefis">
      <div className={style.keyBenefis__header}>
        <span>{t('mainPage.newOpportunitiesTargeting')}</span>
        <a
          href="https://t.me/tgparsin_bot"
          target="_blank"
          className={style.aboutUs__text_link}
        >
          <span style={{ color: '#0176C9' }}>Telegram</span>
        </a>
      </div>
      <div
        className={style.keyBenefis__info}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        ref={wrapperRef}
        style={{ transform: `translateX(${offsetX}px)` }}
      >
        <div className={style.keyBenefis__info_block}>
          <span>{t('mainPage.userFriendlyInterface')}</span>
        </div>
        <div className={style.keyBenefis__info_block}>
          <span>{t('mainPage.entryTelegramTargetingFrom50')}</span>
        </div>
        <div className={style.keyBenefis__info_block}>
          <span>{t('mainPage.parsersWithTargetingCombo')}</span>
        </div>
        <div className={style.keyBenefis__info_block}>
          <span>{t('mainPage.automaticRefundUndeliveredAds')}</span>
        </div>
        <div className={style.keyBenefis__info_block}>
          <span>{t('mainPage.brandingAdsImportant')}</span>
        </div>
        <div className={style.keyBenefis__info_block}>
          <span>{t('mainPage.collectLocalAudienceGeo')}</span>
        </div>
      </div>
      <div className={style.keybenefis__graph}>
        <picture>
          <source
            media="(max-width: 500px)"
            srcSet={
              i18n.language === 'ru'
                ? KeyBenefis__icon_500
                : KeyBenefis__icon_500_en
            }
            width="320px"
          />
          <source
            media="(max-width: 900px)"
            srcSet={
              i18n.language === 'ru'
                ? KeyBenefis__icon_900
                : KeyBenefis__icon_900_en
            }
            width="728px"
          />
          <source
            media="(max-width: 1730px)"
            srcSet={
              i18n.language === 'ru' ? KeyBenefis__icon : KeyBenefis__icon_en
            }
            width="1140px"
          />
          <img
            src={
              i18n.language === 'ru'
                ? KeyBenefis__icon_1920
                : KeyBenefis__icon_1920_en
            }
            alt={t('mainPage.keyAdvantages')}
            width="100%"
          />
        </picture>
      </div>
    </div>
  );
}
